import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import AddFixedAttributeValueToNarrativeButton from './AddFixedAttributeValueToNarrativeButton';
import AddNumericAttributeValueToNarrativeButton from './AddNumericAttributeValueToNarrativeButton';

export default function AddAttributeValueToNarrativeForm(props) {
  const { actionListId, onSuccess } = props;

  return (
    <Grid container>
      <Grid item xs={6}>
        <AddFixedAttributeValueToNarrativeButton
          actionListId={actionListId}
          parentOnSuccess={onSuccess}
        />
        <AddNumericAttributeValueToNarrativeButton
          actionListId={actionListId}
          parentOnSuccess={onSuccess}
        />
      </Grid>
    </Grid>
  );
}

AddAttributeValueToNarrativeForm.propTypes = {
  actionListId: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
